/**
 * Canonical sub-heading under every firm name across every table page in Pulse.
 *
 * Renders exactly three slots: firm URL · city · activation date.
 * Keeping this in one component guarantees the dashboard, new/old customers,
 * enterprise, renewals, power users and follow-ups all stay visually identical.
 */
export function FirmSubmeta({ firm, className = "" }) {
  if (!firm) return null;
  const url = firm.firm_url || (firm.subdomain ? `${firm.subdomain}.assureai.in` : "—");
  const city = firm.city || "—";
  const activation = firm.activation_date || "—";
  return (
    <div
      className={`text-[11px] text-gray-500 mt-0.5 flex items-center gap-2 font-mono ${className}`}
      data-testid={`firm-submeta-${firm.subdomain || ""}`}
    >
      <span>{url}</span>
      <span className="text-gray-300">·</span>
      <span>{city}</span>
      <span className="text-gray-300">·</span>
      <span>{activation}</span>
    </div>
  );
}
